import React from 'react'
import PropTypes from 'prop-types'

import Text from './Text.jsx'

import useRect from '../hooks/useRect'
import usePosition from '../hooks/usePosition'

function Notes(props) {
  const { content, align, DelegatedRect } = props

  const [textRef, textRect] = usePosition()
  const [Rect, rect] = useRect()

  return (
    <svg x={0} y={0} width={'100%'} height={textRect.height}>
      {DelegatedRect && <DelegatedRect />}
      {Rect && <Rect />}
      <Text
        gRef={textRef}
        value={content}
        fontSize={24}
        fontWeight={400}
        fontStyle="italic"
        textAnchor={align}
        fill={'#666666'}
        width={rect.width}
        x={0}
        y={0}
      />
    </svg>
  )
}

Notes.propTypes = {
  content: PropTypes.string.isRequired,
  align: PropTypes.string,
  DelegatedRect: PropTypes.func,
}

Notes.defaultProps = {
  align: '',
  DelegatedRect: () => {},
}

export default Notes
